import styled from "styled-components";
import { colorTheme, textTheme } from "../../../theme";
import LoginImage from "../../../assets/Login/side.png";

export const Page = styled.div`
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: "header" "main" "footer";
`;

export const Main = styled.div`
  width: 100vw;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: "main" "image";
`;

export const LoginContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const LoginArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-self: stretch;
  justify-self: end;
  box-sizing: border-box;
  max-width: 720px;
  width: 100%;
  padding: 62px 34px;
`;

export const Header = styled.div`
  color: ${colorTheme.black};
  ${textTheme.h3};
`;

export const LoginText = styled.p`
  margin: 0;
  padding: 0;
  ${textTheme.body2};
`;

export const LoginButton = styled.button`
  width: min-content;
  background: ${colorTheme.newBlue};
  padding: 12px 30px;
  box-shadow: 0px 4px 10px rgba(16, 156, 241, 0.06);
  border-radius: 4px;
  border: none;
  cursor: pointer;

  color: ${colorTheme.white};
  ${textTheme.button};
`;

export const LoginSide = styled.div`
  background-image: url("${LoginImage}");
  //background-color: ${colorTheme.newBlue};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-blend-mode: soft-light;
  align-self: stretch;
`;
